// extracted by mini-css-extract-plugin
export default {"borderGrey":"#b5b4b5","zIndexModalBackdrop":"1040","container":"CSJvsPAQIRCVvV85"};